export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Category\",\n    \"label_plural\": \"{{count}} Categories\"\n}\n"